import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getCurrentUserMenuRolePermissions } from '../../pages/admin/rolePermission/api'

export const fetchGetDynamicConfigAsync = createAsyncThunk(
  'dynamicConfig/currentUserMenuRolePermissions',
  () =>
    axios.get(getCurrentUserMenuRolePermissions()).then((response) => {
      return response?.data ?? []
    })
)

const dynamicConfigSlice = createSlice({
  name: 'dynamicConfig',
  initialState: {
    dynamicConfigList: [],
    dynamicConfigDict: {},
  },
  reducers: {
    setDynamicConfigList(state, action) {
      state.dynamicConfigList = action.payload
    },
    setDynamicConfigDict(state, action) {
      state.dynamicConfigDict = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetDynamicConfigAsync.pending, (state) => {
        state.dynamicConfigList = []
        state.dynamicConfigDict = {}
      })
      .addCase(fetchGetDynamicConfigAsync.fulfilled, (state, action) => {
        state.dynamicConfigList = action.payload
        if (state.dynamicConfigList) {
          state.dynamicConfigList.forEach((item) => {
            state.dynamicConfigDict[item.menuId] = item
          })
        }
      })
  },
})

export const { setDynamicConfigList, setDynamicConfigDict } =
  dynamicConfigSlice.actions
export const getDynamicConfigList = (state) =>
  state.dynamicConfig.dynamicConfigList
export const getDynamicConfigDict = (state) =>
  state.dynamicConfig.dynamicConfigDict
export default dynamicConfigSlice.reducer
